export default {"src":"/_next/static/media/icon-apartments.1e18b4ac.svg","height":30,"width":21,"blurWidth":0,"blurHeight":0};